var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/docs/doc-plus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3732 6.3002L42.697 15.537C42.8899 15.7295 43 15.9899 43 16.2632V41.9211C43 43.6183 41.6053 45 39.8921 45H12.9568C11.2436 45 9.84892 43.6183 9.84892 41.9211V29.477H8.03597C7.4636 29.477 7 29.0177 7 28.4507C7 27.8836 7.4636 27.4243 8.03597 27.4243H9.84892V9.07895C9.84892 7.38168 11.2436 6 12.9568 6H32.6403C32.9148 6 33.179 6.10776 33.3732 6.3002ZM9.84925 29.477H19.4317V40.7664C19.4317 41.3335 19.8953 41.7928 20.4676 41.7928C21.04 41.7928 21.5036 41.3335 21.5036 40.7664V29.477H32.8993C33.4717 29.477 33.9353 29.0177 33.9353 28.4507C33.9353 27.8836 33.4717 27.4243 32.8993 27.4243H21.5036V16.1349C21.5036 15.5678 21.04 15.1086 20.4676 15.1086C19.8953 15.1086 19.4317 15.5678 19.4317 16.1349V27.4243H9.84925V26.3662C9.84925 26.3423 9.88349 26.3733 9.94632 26.4302C10.2194 26.6776 11.0324 27.4141 11.9209 26.2545V9.07895C11.9209 8.51191 12.3845 8.05263 12.9568 8.05263H30.5683V15.2368C30.5683 16.9341 31.963 18.3158 33.6763 18.3158H40.9281V41.9211C40.9281 42.4881 40.4645 42.9474 39.8921 42.9474H12.9568C12.3845 42.9474 11.9209 42.4881 11.9209 41.9211V30.5665C10.9064 29.7854 10.1148 30.3761 9.9044 30.5331C9.86824 30.5601 9.84925 30.5743 9.84925 30.5665V29.477ZM33.6763 16.2632H40.4994L32.6403 8.47727V15.2368C32.6403 15.8039 33.1039 16.2632 33.6763 16.2632Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocPlus);
export default __webpack_public_path__ + "static/media/doc-plus.24dd7060875b46c8f241f3e57fc05471.svg";
export { ForwardRef as ReactComponent };